import { useState, useEffect } from "react";
import Store from "../../../Stores/Store";
import style from "./UpBalance.module.scss";
import Heading from "../../Typography/Heading/Heading";
import Text from "../../Typography/Text/Text";
import {
  inputFocusMessage,
  closeIframeMessage,
} from "../../../Utils/iframeMessenger";
import Button from "../../Button/Button";
import LsBalance from "./LsBalance/LsBalance";
import toMainImg from "../../../Static/images/toMainImg.svg";

const UpBalance = ({ setModalUpBalanceActive, balanceInfo, debt }) => {
  const [totalInputValue, setTotalInputValue] = useState(
    debt >= 0 ? 0 : Math.abs(debt)
  );
  const [totalTaxValue, setTotalTaxValue] = useState(
      0
  );
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function backToBalance() {
    setModalUpBalanceActive(false);
  }

  function totalInputChange(value) {
    let filteredValue;
    filteredValue = value
      .replace(/^[^\d]/g, "")
      .replace(/[^\d.]/g, "")
      .replace(/^([^.]*\.)|\./g, "$1");
    if (filteredValue.indexOf(".") !== -1) {
      filteredValue = filteredValue.substring(
        0,
        filteredValue.indexOf(".") + 3
      );
    }
    setTotalInputValue(Number(filteredValue));
    calculateAndSetLssInputsValue(filteredValue);
  }

  function calculateAndSetLssInputsValue(totalValue) {
    if (balanceInfo.totalNegativeBalance || balanceInfo.totalPositiveBalance) {
      calculateAndSetLssInputsValueWithProportionalShares(totalValue);
    } else if (
      !balanceInfo.totalNegativeBalance &&
      !balanceInfo.totalPositiveBalance
    ) {
      calculateAndSetLssInputsValueWithEqualShares(totalValue);
    }
  }

  function calculateAndSetLssInputsValueWithProportionalShares(totalValue) {
    if (balanceInfo.totalNegativeBalance) {
      calculateNegativeBalanceProportionalShares(totalValue);
    } else if (balanceInfo.totalPositiveBalance) {
      calculatePositiveBalanceProportionalShares(totalValue);
    }
  }

  function calculateNegativeBalanceProportionalShares(totalValue) {
    const lssInputs = document.getElementsByName("lsInput");
    lssInputs.forEach((item, idx) => {
      if (balanceInfo.accounts[idx].totalAccountNegativeBalance) {
        item.value = Number(
          (
            (balanceInfo.accounts[idx].totalAccountNegativeBalance /
              balanceInfo.totalNegativeBalance) *
            totalValue
          ).toFixed(2)
        );
      }
    });
  }

  function calculatePositiveBalanceProportionalShares(totalValue) {
    const lssInputs = document.getElementsByName("lsInput");
    lssInputs.forEach((item, idx) => {
      if (balanceInfo.accounts[idx].totalAccountPositiveBalance) {
        item.value = Number(
          (
            (balanceInfo.accounts[idx].totalAccountPositiveBalance /
              balanceInfo.totalPositiveBalance) *
            totalValue
          ).toFixed(2)
        );
      }
    });
  }

  function calculateAndSetLssInputsValueWithEqualShares(value) {
    const lssInputs = document.getElementsByName("lsInput");
    let lsInputValue = value / lssInputs.length;
    lsInputValue = Math.floor(lsInputValue.toFixed(3) * 100) / 100;
    let dif = Number(value) - lsInputValue * lssInputs.length;
    dif = Number(dif.toFixed(2));
    lssInputs.forEach((item, idx) => {
      if (idx !== 0) {
        item.value = lsInputValue.toFixed(2);
      } else {
        item.value = (lsInputValue + dif).toFixed(2);
      }
    });
  }

  function lsInputChange() {
    const lssInputs = document.getElementsByName("lsInput");
    let totalValue = 0;
    lssInputs.forEach((item) => {
      totalValue = totalValue + Number(item.value);
    });
    totalValue = Number(totalValue.toFixed(2));
    setTotalInputValue(totalValue);

    let taxValue = 0;
    lssInputs.forEach((item,id) => {
      const tax_percent = JSON.parse(JSON.stringify(balanceInfo)).accounts[id].tax_percent
      if(tax_percent>0) {
        const val = Number(item.value) * tax_percent
        taxValue = taxValue + val;
      }
    });
    taxValue = Number(taxValue.toFixed(2));
    setTotalTaxValue(taxValue);
  }

  function setCorrectPaymentInfo(paymentInfo) {
    //Создаем json для эндпоинта эквайринга /create. Создается на основе /saldo_info (так исторически сложилось)
    const lssInputs = document.getElementsByName("lsInput");
    let tempData = paymentInfo;
    tempData.type = "payment";
    tempData.is_infomat = true;
    tempData.payment_method_id = 8
    delete tempData.totalNegativeBalance;
    delete tempData.totalPositiveBalance;    
    if (tempData.unified_number) {
      tempData.unified_id = Store.payment.accounts.id_unified_account;
    } else {
      tempData.unified_id = null;
      tempData.unified_number = null;
      tempData.code = Store.payment.accountInfo.number;
    }
    tempData.accounts.forEach((account, idx) => {
      delete account.totalAccountNegativeBalance;
      delete account.totalAccountPositiveBalance;
      delete account.number;
      delete account.id_org;
      delete account.service_name;
      delete account.services;
      account.amount = Math.round(lssInputs[idx].value * 100);
      if(account.tax_percent>0){
        account.tax_amount = Math.round(account.amount * account.tax_percent)
        account.amount = account.amount + account.tax_amount;
      } else {
        account.tax_amount = 0
      }
      delete account.tax_percent;
    });
    tempData.email = "";
    tempData.amount = Number(((totalInputValue + totalTaxValue) * 100).toFixed(2));
    Store.payment.setTerminalPaymentInfo(tempData);    
  }

  function toPaymentWindow() {
    if (totalInputValue > 0) {
      setCorrectPaymentInfo(JSON.parse(JSON.stringify(balanceInfo)));
      Store.payment.setAmount(Store.payment.terminalPaymentInfo.amount);
      Store.payment.setPaymentWindowActive(true);
    }
  }

  function sum_with_tax_percent() {
    if(totalInputValue >= 0 && totalTaxValue >= 0){
      return Number((Number(totalInputValue) + Number(totalTaxValue)).toFixed(2))
    }
  }
  
  return (
    <div className={style.modalUpBalance}>
      <div
        className={style.modalUpBalance__wrap}
        //onClick={(e) => e.stopPropagation()}
      >
        <div className={style.modalUpBalance__wrap__back}>
          <div className={style.toMain} onClick={() => closeIframeMessage()}>
            <img src={toMainImg} alt="" />
            <Text size="medium">Главная</Text>
          </div>
          <div className={style.devider}>/</div>
          <div className={style.back} onClick={() => backToBalance()}>
            <Text size="medium">Назад</Text>
          </div>
        </div>

        <div className={style.modalUpBalance__wrap__title}>
          <Heading level="h3">
            {balanceInfo?.unified_number
              ? `ЕЛС № ${balanceInfo.unified_number}`
              : `ЛС № ${Store.payment.accountInfo.number}`}
          </Heading>
        </div>
        <div className={style.modalUpBalance__wrap__content}>
          {balanceInfo.accounts.map((item, idx) => {
            return (
              <LsBalance
                lsBalanceInfo={item}
                lsInputChange={lsInputChange}
                key={idx}
              />
            );
          })}
          <div className={style.modalUpBalance__wrap__content__total}>
            <div className={style.title}>Общая сумма</div>
            <input
              onChange={(e) => totalInputChange(e.target.value)}
              value={totalInputValue}
              className={style.sumInput}
              onFocus={() => inputFocusMessage("openNumKeyboard")}
              onBlur={() => inputFocusMessage("closeKeyboard")}
              maxLength={10}
            />
          </div>
          <div className={style.tax}>
            Комиссия: {totalTaxValue}
          </div>
          <div className={style.tax}>
            Итого к оплате: {sum_with_tax_percent()}
          </div>
          <Button
            clickHandler={toPaymentWindow}
            disabled={Number(totalInputValue) === 0 || !totalInputValue}
          >
            Далее
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UpBalance;
